// extracted by mini-css-extract-plugin
module.exports = {"ant-advanced-search-form":"PersonMng_ant-advanced-search-form__2XJ_e","PersonMng":"PersonMng_PersonMng__463Fp"};